import { render, staticRenderFns } from "./channel-detail-tile.vue?vue&type=template&id=79ea3013&scoped=true"
import script from "./channel-detail-tile.vue?vue&type=script&setup=true&lang=js"
export * from "./channel-detail-tile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel-detail-tile.vue?vue&type=style&index=0&id=79ea3013&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ea3013",
  null
  
)

export default component.exports